import { SCHEMA_ANOMALY_DETECTION_EXPECTATION_TYPE } from "src/pages/DataAssets/views/Expectations/ExpectationsTable"

export function isAnomalyDetectionExpectation(
  expectationType?: string | null,
  windowsKwargs?: Record<string, unknown>[],
) {
  return expectationType === SCHEMA_ANOMALY_DETECTION_EXPECTATION_TYPE || (windowsKwargs?.length ?? 0) > 0
}
